export enum ReportsDashboardMutations {
    SET_STATE = 'SET_STATE',
}
